import { WorkorderLaborWithContext } from '@certhon/models';
import { StackLink } from '@/app/navigation/StackLink';
import { cn } from '@/lib/utils';
import {
  calculateLaborHours,
  formatHours,
  formatTime,
} from '../my-hours.utils';
import { firstLine } from '@/utils/string';

interface LaborEntryRowProps {
  entry: WorkorderLaborWithContext;
  /** Panel path; the row drills down to its workorder below it. */
  linkBase: string;
}

export function LaborEntryRow({ entry, linkBase }: LaborEntryRowProps) {
  const hours = calculateLaborHours(entry);
  const isCompleted = entry.workorder.completed;

  const title = `W${entry.workorder_id} ${entry.workorder.customer_name || 'Unknown customer'}`;

  return (
    <StackLink
      to={`${linkBase}/workorders/${entry.workorder_id}/labor`}
      className={cn(
        `flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border px-3 py-2
        no-underline transition-colors`,
        isCompleted
          ? `border-green-200 bg-green-50/50 hover:bg-green-100/70 dark:border-green-900
            dark:bg-green-950/40 dark:hover:bg-green-900/60`
          : `border-amber-200 bg-amber-50/50 hover:bg-amber-100/70 dark:border-amber-900
            dark:bg-amber-950/40 dark:hover:bg-amber-900/60`,
      )}
    >
      {/* Time range - stacks below on mobile */}
      <div className="text-muted-foreground order-1 w-full text-xs sm:order-none sm:w-auto">
        {formatTime(entry.date_start)} - {formatTime(entry.date_stop)}
      </div>

      {/* Workorder info */}
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-medium">{title}</div>
        {entry.workorder.description && (
          <div className="text-muted-foreground truncate text-xs">
            {firstLine(entry.workorder.description)}
          </div>
        )}
      </div>

      {/* Hours */}
      <div className="text-muted-foreground shrink-0 text-sm">
        {formatHours(hours)}
      </div>
    </StackLink>
  );
}
